import { useEffect, useState } from "react"
import { Form, Mode, readFormFromDB } from "../../components/shared/Form/Form"
import { Loading } from "../../components/shared";
import { NotificationManager } from 'react-notifications';
import _ from "lodash";
import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";
import { ServiceSupplierApplicationForm } from "../../services/service-supplier-application-form";
import Card from "../../components/shared/Card/card";
import appState from "../../state/AppStateContainer";
import InfoBanner from "../page-dashboard-V2/InfoBanner/InfoBanner";

const SupplierApplicationFormSettings = () => {
  const [form, setForm] = useState<Form>();
  const [t] = useTranslation('marketing');
  const [t2] = useTranslation('shared', { keyPrefix: 'form' });

  useEffect(() => {
    (async () => {
      const form = await ServiceSupplierApplicationForm.getSupplierApplicationFormForOrganization();
      setForm(readFormFromDB(form, Mode.EDIT));
    })()
  }, [])
  

  const onSubmit = async (form: Form) => {
    if (!form) return;

    try {
      await ServiceSupplierApplicationForm.updateSupplierApplicationFormForOrganization(form);
      NotificationManager.success(t2('notification.success.saved', 'Formularen har sparats'));
    } catch (error) {
      const errorMsg = _.get(error, 'response.data.error', t('notification.error.description', 'Oväntat fel ({{error}})', { error }));
      NotificationManager.error(errorMsg, t('notification.error.title', 'Misslyckat'));
      Sentry.captureException(error);
    }
  }

  if (!form) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}><Loading type="inline" /></div>

  const getRenderWrapperForMode = (mode: Mode) => {
    const render = (children: JSX.Element) => {
      return form.mode === Mode.EDIT && mode === Mode.FORM ? (
        <div style={{ width: '710px', margin: '0 auto', display: 'flex', flexDirection: 'column' }}>
          <Card  style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <InfoBanner>
              <p style={{ fontSize: '14px' }}>
                {t2('formSettingsDescription', 'Detta är en förhandsvisning av de nya frågor som kommer att läggas till i leverantörsformuläret. Standardfrågorna (t.ex. org.nr/VAT-nummer, företagsnamn, logotyp, adress, kommun m.m.) ligger kvar oförändrade. De nya frågorna placeras mellan avsnitten Kontaktpersoner och Övriga uppgifter.')}
              </p>
            </InfoBanner>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              {children}
            </div>
          </Card>
        </div>
      ) : (
        children
      )
    }
    return render;
  }
  return (
    <Form form={form} onFormChange={setForm} onSubmit={onSubmit} getRenderWrapperForMode={getRenderWrapperForMode} goLiveButtonOptions={{ label: t2('goLiveButton', 'Go to live'), url: `/${appState.currentOrganization.slug}/new-supplier` }} />
  )
}

export default SupplierApplicationFormSettings;